import React, { useState } from "react";
import { Table, Select, Button, Input, Tooltip } from "antd";
import styles from "./SupervisorComponentManagement.module.css";
import { useNavigate } from "react-router-dom";
import actionicon from "../../../../../assets/images/actionicon.svg";
import { SubmitButton } from "../../../../../components";
import HeaderComponent from "../../../../../components/HeaderComponent/HeaderComponent";
import { Modal, SearchInput } from "../../../../../components";
import { SearchOutlined } from "@ant-design/icons";

const { Option } = Select;


const ComponentManagement = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [filterModal, setFilterModal] = useState(false);

  const columns = [
    {
      title: "Component Name",
      dataIndex: "ComponentName",
      key: "ComponentName",
      render: (text, record) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
          {(record.ComponentName === "Pie Crust Dough" ||
            record.ComponentName === "Choux Pastry Shells" ||
            record.ComponentName === "Brownie Base" ||
            record.ComponentName === "Cookie Dough" ||
            record.ComponentName === "Tart Shells") && (
              // <img src={actionicon} alt="icon" className={styles.iconImg} />
              <Tooltip title="Allergy">
                <img
                  src={actionicon}
                  alt="clone"
                  className={styles.iconImg}
                  style={{ cursor: "pointer" }}
                />
              </Tooltip>
            )}
        </div>
      ),
    },
    {
      title: "Product Tag",
      key: "ProductTag",
      dataIndex: "ProductTag",
    },
    {
      title: "Quantity",
      dataIndex: "Quantity",
      key: "Quantity",
    },
    {
      title: "",
      key: "action",
      dataIndex: "Button",
      render: (text, record) => record.Button,
    },
  ];

  const data = [
    {
      ComponentName: "Pie Crust Dough",
      Quantity: "2 lbs",
      ProductTag: "Cake ",
      Button:
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => navigate("/Warehouse/SupervisorRecipeDetails")}
        />
    },
    {
      ComponentName: "Choux Pastry Shells",
      Quantity: "36 oz",
      ProductTag: "Cookies",
      Button: <SubmitButton
        title={"View"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/Warehouse/SupervisorRecipeDetails")}
      />
    },
    {
      ComponentName: "Pizza Dough Balls",
      Quantity: "3 lbs",
      ProductTag: "bread",
      Button: <SubmitButton
        title={"View"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/Warehouse/SupervisorRecipeDetails")}
      />
    },
    {
      ComponentName: "Brownie Base",
      Quantity: "4 g",
      ProductTag: "Cake",
      Button: <SubmitButton
        title={"View"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/Warehouse/SupervisorRecipeDetails")}
      />
    },
    {
      ComponentName: "Sponge Cake Layers",
      Quantity: "36 oz",
      ProductTag: "Cookies",
      Button: <SubmitButton
        title={"View"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/Warehouse/SupervisorRecipeDetails")}
      />
    },
    {
      ComponentName: "Shortbread Base",
      Quantity: "3 lbs",
      ProductTag: "bread",
      Button: <SubmitButton
        title={"View"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/Warehouse/SupervisorRecipeDetails")}
      />
    },
    {
      ComponentName: "Cookie Dough",
      Quantity: "2 lbs",
      ProductTag: "bread",
      Button: <SubmitButton
        title={"View"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/Warehouse/SupervisorRecipeDetails")}
      />
    },
    {
      ComponentName: "Bread Dough",
      Quantity: "4 g",
      ProductTag: "Cake",
      Button: <SubmitButton
        title={"View"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/Warehouse/SupervisorRecipeDetails")}
      />
    },
    {
      ComponentName: "Tart Shells",
      Quantity: "3 lbs",
      ProductTag: "Cookies",
      Button: <SubmitButton
        title={"View"}
        primary
        btnClass={styles.actionBtn}
        onClick={() => navigate("/Warehouse/SupervisorRecipeDetails")}
      />
    },
  ];

  return (
    <div className={styles.mainCont}>
      <HeaderComponent
        heading={"Component"}
        onSearch={(e) => console.log(e.target.value)}
        headingStyle={styles.headingStyle}
        // onSubmit={() => navigate("/Warehouse/ComponentMGMT/CreateComponent")}
        // submitButtonText={"Create Component"}
        rightControlsStyle={styles.rightControlsStyle}
        // showBackIcon={true}
        showFilterIcon={true}
        showSubmitButton={false}
        showSearch={true}
        onClickFilter={() => setFilterModal(true)}

      />

      <div className={styles.subCont}>
        <div className={styles.TableDiv}>
          <Table
            scroll={{ x: true }}
            columns={columns}
            dataSource={data}
            pagination={false}
            rowKey="No"
          />
        </div>
      </div>


      {/* //////////////////// Filters ////////////////////// */}

      <Modal
        open={filterModal}
        onCancel={() => {
          setFilterModal(false);
        }}
        className={styles.modalCont}
        title={"Filters"}
        headingClass={styles.modalHeading}
        width={"400px"}
        // btnStyle={{ width: "200px", }}
        twoButton
        okBtnTitle={"Apply Filters(1)"}
        cancelBtnTitle={"Reset All"}
        onClickCancelButton={() => setFilterModal(false)}
        onClickOkButton={() => {
          setFilterModal(false)
        }}
      // onBtnPress={() => setLimitExceedsModal(false)}
      >
        <div className={styles.modalInp}>
          <SearchInput
            rightIcon={<SearchOutlined />}
            placeholder={"Search Product Tag"}

          />
        </div>

      </Modal>
    </div>
  );
};

export default ComponentManagement;
